import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { PaaRepository } from '../../../../store/paa-state/paa-state.repository';

interface getPaaVersionHistoryDataTableStructureProps {
  store: PaaRepository;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getPaaVersionHistoryDataTableStructure = ({
  store,
  rowActions,
  serverQuery,
}: getPaaVersionHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const versionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.version',
    accessorKey: 'version',
    variant: DataTableColumnVariant.TEXT,
  };

  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const anneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const refreshedColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.refreshed',
    accessorKey: 'actualise',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: value ? 'Oui' : 'Non', class: 'text-xs' };
    },
    props: {
      getSeverity: (value: boolean) => {
        if (value) return 'success';
        return 'danger';
      },
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'paa.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `paa.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const budgetColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ppm.table.budget',
    accessorKey: 'budgetEstime',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: number) => {
      if (value) {
        return { value: value };
      }
      return { value: 'Non défini', class: 'opacity-70' };
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'paa.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'paa.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const acColumnn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'paa.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  // const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'paa.table.created_by',
  //   accessorKey: 'metadata.createdBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  // const updatedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'paa.table.updated_by',
  //   accessorKey: 'metadata.updatedBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  return {
    singular: "Historique des Plans d'Achats",
    plural: "Historiques des Plans d'Achats",
    data: [],
    columns: [
      versionColumn,
      refColumn,
      anneeColumn,
      nomColumn,
      acColumnn,
      refreshedColumn,
      statusColumn,
      processStepColumn,
      budgetColumn,
      createdAtColumn,
      updatedAtColumn,
    ],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.setNested('response', row);
    },
    enableServerActions: true,
    serverQuery,
    rowActions,
    searchableFields: ['ref', 'nom', 'annee', 'status'],
  };
};
